/**
 * Find any object props named like the language code and return only that value,
 * reducing any multi-lingual objects to just the selected language
 *
 * @todo support for default language fallback
 *
 * @param languageCode
 * @returns {localize}
 */
export const createLocaleTextGetter = require('./localeUtils').createLocaleTextGetter;